// src/services/officeLocationService.js
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
});

const authHeaders = (accessToken) => ({
  headers: {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json",
  },
});

/**
 * List office locations. Pass activeOnly to skip disabled branches.
 */
export const getOfficeLocations = (accessToken, { activeOnly = false } = {}) =>
  api
    .get(`/api/office-locations${activeOnly ? "?activeOnly=true" : ""}`, authHeaders(accessToken))
    .then((res) => res.data?.data || []);

export const createOfficeLocation = (accessToken, payload) =>
  api
    .post("/api/office-locations", payload, authHeaders(accessToken))
    .then((res) => res.data?.data);

export const updateOfficeLocation = (accessToken, id, payload) =>
  api
    .put(`/api/office-locations/${id}`, payload, authHeaders(accessToken))
    .then((res) => res.data?.data);

export const deleteOfficeLocation = (accessToken, id) =>
  api
    .delete(`/api/office-locations/${id}`, authHeaders(accessToken))
    .then((res) => res.data?.data);

export default {
  getOfficeLocations,
  createOfficeLocation,
  updateOfficeLocation,
  deleteOfficeLocation,
};
